<ng-container *transloco="let t">
    <div class="training-content">
    <h2>{{ t('practice.title') }}</h2>
    <p>{{ t('practice.subtitle') }}</p>
    </div>
<!-- <div class="tiket-grid">
    <tui-badged-content>
        <tui-badge-notification size="l" tuiSlot="top">
            99
        </tui-badge-notification>
        <tui-avatar size="xl" src="@tui.ticket" [round]="false" />
        <tui-icon appearance="accent" icon="@tui.star" size="l" tuiBadge tuiSlot="bottom" />
    </tui-badged-content>

    <tui-badged-content>
        <tui-badge-notification size="l" tuiSlot="top">
            99
        </tui-badge-notification>
        <tui-avatar size="xl" src="@tui.ticket-percent" [round]="false" />
        <tui-icon appearance="accent" icon="@tui.star" size="l" tuiBadge tuiSlot="bottom" />
    </tui-badged-content>

    <tui-badged-content>
        <tui-avatar size="xl" src="@tui.ticket-check" [round]="false" style="color: rgb(53, 175, 5);" />
    </tui-badged-content>

    <tui-badged-content>
        <tui-badge-notification size="l" tuiSlot="top">
            35
        </tui-badge-notification>
        <tui-avatar size="xl" src="@tui.ticket" [round]="false" style="color: rgb(210, 183, 7);"/>
    </tui-badged-content>

    <tui-badged-content>
        <tui-avatar size="xl" src="@tui.ticket" [round]="false"/>
    </tui-badged-content>

    <tui-badged-content>
        <tui-avatar size="xl" src="@tui.ticket-x" [round]="false" />
        <tui-icon  icon="@tui.lock" size="l" tuiBadge tuiSlot="bottom" />
    </tui-badged-content>

    <tui-badged-content>
        <tui-avatar size="xl" src="@tui.ticket-x" [round]="false" />
        <tui-icon icon="@tui.lock" size="l" tuiBadge tuiSlot="bottom" />
    </tui-badged-content>

    <tui-badged-content>
        <tui-avatar size="xl" src="@tui.ticket-x" [round]="false" />
        <tui-icon icon="@tui.lock" size="l" tuiBadge tuiSlot="bottom" />
    </tui-badged-content>
</div> -->
<!-- routerLink="/ticket/{{item.numb}}/" -->
    <div class="tiket-grid" *ngFor="let items of objTickets">
        <tui-badged-content *ngFor="let item  of items">
            <tui-badge-notification *ngIf="item.bage" size="l" tuiSlot="top">
                99
            </tui-badge-notification>
            <tui-avatar size="xl" src="{{item.ico}}" [round]="false" class="{{item.cl}}"
                (click)="item.cl === 'danger' ? null : router.navigate([ROUTES_CONST.TICKET,item.numb])" />
            <tui-icon *ngIf="!item.link" [icon]="'@tui.lock'" size="l" tuiBadge tuiSlot="bottom" />
        </tui-badged-content>
    </div>
</ng-container>

